class LocalizationStrings
{
    InvalidPC: string = "";
    NorthPlayer: string = "";
    EastPlayer: string = "";
    SouthPlayer: string = "";
    WestPlayer: string = "";
    DealNumberHeader: string = "";
    VulnerabilityHeader: string = "";
    ContractHeader: string = "";
    PlayedTricksHeader: string = "";
    ScoreHeader: string = "";
    PCHeader: string = "";
    CompensationHeader: string = "";
    DeltaHeader: string = "";
    ImpsNSHeader: string = "";
    ImpsWEHeader: string = "";
    ImpsSumHeader: string = "";
    ImpsDiffHeader: string = "";
    StartButton: string = "";
    ChooseButton: string = "";
    BuildNumber: string = "";
}

export let Localization: LocalizationStrings;

function getUndefinedLocalizedStrings(): string[]
{
    let undefinedStrings: string[] = [];
    let defaultLocalization = new LocalizationStrings();
    for (let key of Object.keys(defaultLocalization))
    {
        if (!Localization.hasOwnProperty(key))
        {
            undefinedStrings.push(key);
        }
    }
    return undefinedStrings;
}

async function loadLocalization(lang: string): Promise<void>
{
    let resp: Response = await fetch(`${lang}/Strings.json`);
    Localization = await resp.json();
    let undefinedStrings: string[] = getUndefinedLocalizedStrings();
    if (undefinedStrings.length > 0)
    {
        console.warn(`Localization for '${lang}' is missing the following strings:\n${undefinedStrings.join('\n')}`);
    }
}

export async function InitLocalization(): Promise<void>
{
    let storedLang: string = localStorage.getItem('lang') || 'en';
    await loadLocalization(storedLang);
    let selectElement: HTMLSelectElement = document.getElementById("language-select") as HTMLSelectElement;
    selectElement.value = storedLang;
    selectElement.onchange = languageChanged;
}

function languageChanged(event: Event): void
{
    let selectElement: HTMLSelectElement = event.target as HTMLSelectElement;
    localStorage.setItem('lang', selectElement.value);
    location.reload();
}